/**
 * Advantage Flow's pitch, in one place: the landing page at /afs (AFSLanding.jsx) and the locked preview a member
 * without Advantage Flow sees at #/afs (AFSLockedPreview.jsx) say the same thing, so neither can drift or make a claim
 * the other doesn't.
 */

// The headline (brief 679, was "Stop flying blind."), one line to change.
export const HEADLINE = "Every possession, explained.";
// The founder's words, 2026-11-01 (brief 672).
export const SUB = "The anatomy of your offense: every advantage, why it's kept or lost, who makes it happen, which plays work best. And that's just the surface. Tag it by voice, or we'll do it for you.";

/** How it works: [the landing page's motion piece, title, line]. */
export const HOW = [
  ["how-talk", "Talk over your film", "Say what you see as it plays. The tags fill themselves in, and it only asks about what's missing."],
  ["how-chain", "See the whole chain", "Who beat his man, the pass that kept it alive, and how it ended, possession by possession."],
  ["how-numbers", "Open the numbers", "Creation, keeping it and why, with the plays behind every number. Click one and watch them."],
];

/** The public landing page (App.js mounts AFSLanding on this path), where Get started and the plans are. */
export const AFS_LANDING_PATH = "/afs";

/**
 * Whether the sidebar shows Advantage Flow (2026-11-03: "make the afs sidebar nav visible to everyone with just a very
 * basic preview / locked screen"). Every signed-in account on the web: with Advantage Flow it opens the app, without it
 * the locked preview. Never in the iOS app (CLAUDE.md B: AFS is web-only, and a teaser there that sends people to buy
 * outside Apple's in-app purchase breaks the anti-steering rule).
 */
export function afsInSidebar({ signedIn, native }) {
  return !!signedIn && !native;
}
